import { NodeType } from "../NodeType";

export {
  ApiMethod,
  TExternalApiNode,
  TExternalApiConfig,
  AuthenticationType,
  TAuthentication,
  TAuthenticationBasic,
  TAuthenticationApiKey,
  TAuthenticationBearer,
  TAuthenticationNode,
  FieldMappingTransform,
  TFieldMapping,
  defaultExternalApiNode
};

const ApiMethod = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
} as const;

type ApiMethod = (typeof ApiMethod)[keyof typeof ApiMethod];

type TExternalApiNode = {
  nodeId: string;
  type: typeof NodeType.EXTERNAL_API;
  name: string;
  description?: string;
  config: TExternalApiConfig;
};

type TExternalApiConfig = {
  name: string;
  description?: string;
  method: ApiMethod;
  url: string;
  headers?: Record<string, string>;
  body?: any;
  queryParams?: Record<string, string>;
  timeout?: number;
  retries?: number;
  retryDelayMs?: number;
  responseMapping?: Array<TFieldMapping>;
};

const AuthenticationType = {
  NONE: "none",
  BEARER: "bearer",
  API_KEY: "api_key",
  BASIC: "basic",
};

type AuthenticationType =
  (typeof AuthenticationType)[keyof typeof AuthenticationType];

type TAuthentication =
  | TAuthenticationNode
  | TAuthenticationBearer
  | TAuthenticationApiKey
  | TAuthenticationBasic;

type TAuthenticationNode = {
  type: typeof AuthenticationType.NONE;
};

type TAuthenticationBearer = {
  type: typeof AuthenticationType.BEARER;
  token: string;
};

type TAuthenticationApiKey = {
  type: typeof AuthenticationType.API_KEY;
  apiKeyHeader: string;
  apiKeyValue: string;
};

type TAuthenticationBasic = {
  type: typeof AuthenticationType.BASIC;
  username: string;
  password: string;
};

const FieldMappingTransform = {
  NONE: "none",
  UPPERCASE: "uppercase",
  LOWERCASE: "lowercase",
  TRIM: "trim",
  TO_STRING: "toString",
  TO_NUMBER: "toNumber",
  TO_BOOLEAN: "toBoolean",
} as const;

type FieldMappingTransform =
  (typeof FieldMappingTransform)[keyof typeof FieldMappingTransform];

type TFieldMapping = {
  sourceField: string;
  targetField: string;
  transform: typeof FieldMappingTransform;
  defaultValue?: any;
  isRequired?: boolean;
};

const defaultExternalApiNode = {
  name: "External API",
  url: "",
  method: ApiMethod.GET,
  body: JSON.stringify({}),
  queryParams: {},
  headers: {},
  authentication: { type: AuthenticationType.NONE },
};
